import { authState } from "@/plugins/keycloak";
import { logger } from "../services/LoggerService";
export class KeycloakAuthService {
    async initialize() {
        try {
            return new Promise((resolve) => {
                const checkInitialization = () => {
                    if (authState.isInitialized) {
                        resolve(authState.isAuthenticated);
                    }
                    else {
                        setTimeout(checkInitialization, 100);
                    }
                };
                checkInitialization();
            });
        }
        catch (error) {
            logger.debug("Keycloak initialization failed:", error);
            return false;
        }
    }
    isAuthenticated() {
        return authState.isAuthenticated;
    }
    isInitialized() {
        return authState.isInitialized;
    }
    async login(options) {
        try {
            await authState.login({
                redirectUri: options?.redirectUri,
                loginHint: options?.loginHint,
            });
        }
        catch (error) {
            logger.debug("Keycloak login failed:", error);
            throw error;
        }
    }
    async logout() {
        try {
            await authState.logout();
        }
        catch (error) {
            logger.debug("Keycloak logout failed:", error);
            throw error;
        }
    }
    getUserInfo() {
        if (!authState.keycloakInstance?.tokenParsed) {
            return null;
        }
        const tokenParsed = authState.keycloakInstance.tokenParsed;
        return {
            sub: tokenParsed.sub,
            email: tokenParsed.email,
            name: tokenParsed.name,
            preferred_username: tokenParsed.preferred_username,
            roles: tokenParsed.realm_access?.roles || [],
            given_name: tokenParsed.given_name,
            family_name: tokenParsed.family_name,
            email_verified: tokenParsed.email_verified,
            locale: tokenParsed.locale || "en",
        };
    }
    getToken() {
        return authState.keycloakInstance?.token;
    }
    isTokenExpired(minValidity = 30) {
        return authState.keycloakInstance?.isTokenExpired(minValidity) ?? true;
    }
    async refreshToken() {
        if (!authState.keycloakInstance) {
            return false;
        }
        try {
            const refreshed = await authState.keycloakInstance.updateToken(30);
            return refreshed || authState.keycloakInstance.authenticated || false;
        }
        catch (error) {
            logger.debug("Token refresh failed:", error);
            return false;
        }
    }
    async forceRefreshToken() {
        if (!authState.keycloakInstance) {
            return false;
        }
        try {
            const refreshed = await authState.keycloakInstance.updateToken(-1);
            return refreshed || authState.keycloakInstance.authenticated || false;
        }
        catch (error) {
            logger.debug("Force token refresh failed:", error);
            return false;
        }
    }
    async reinitialize() {
        await authState.reinitialize();
    }
    getUserRoles() {
        const userInfo = this.getUserInfo();
        return userInfo?.roles || [];
    }
    hasRole(role) {
        const roles = this.getUserRoles();
        return roles.includes(role);
    }
    hasAnyRole(roles) {
        const userRoles = this.getUserRoles();
        return roles.some((role) => userRoles.includes(role));
    }
}
export const keycloakAuthService = new KeycloakAuthService();
